import { render } from "./DeveloperListView.vue?vue&type=template&id=20127c23"
import script from "./DeveloperListView.vue?vue&type=script&lang=js"
export * from "./DeveloperListView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__